export default "__VITE_ASSET__CCO3rJ21__"